import { get, find, noop, toString } from 'lodash';
import { AnalyticsTypes, RedirectLabels } from '../../middleware/google-analytics';
import { ActionTypes } from './constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../EventTrackingConstants';
import { HeaderStore } from '@zocdoc/components/src/Layout';
import { appointmentsSelector, notificationsSelector, userSelector } from '@zocdoc/components/src/Layout/selectors';

export const trackPageHeaderLogoClick = () => ({
    type: ActionTypes.TRACK_PAGEHEADER_LOGO_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click PageHeader Logo',
            data: {
                Section: TARGETS.PAGE_HEADER,
                Component: TARGETS.PAGE_HEADER_LOGO,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.PAGE_HEADER_LOGO,
                EventAction: 'click page header logo',
            },
        },
    },
});

export const trackPageHeaderCTALinkClick = () => {
    return ({
        type: ActionTypes.TRACK_PAGEHEADER_CTALINK_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Click PageHeader CTA Link',
                data: {
                    Section: TARGETS.PAGE_HEADER,
                    Component: TARGETS.PAGE_HEADER_CTA_LINK,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Initiator: EVENT_INITIATORS.USER,
                    Element: TARGETS.PAGE_HEADER_LIST_YOUR_PRACTICE,
                    EventAction: 'click page header list your practice',
                    Redirect: RedirectLabels.Internal,
                },
            },
        },
    });
};

export const trackUniversalSearchHeaderSubmit = () => {
    return ({
        type: ActionTypes.TRACK_UNIVERSAL_SEARCH_HEADER_SUBMIT,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Click Universal Search Header Submit',
                data: {
                    Section: TARGETS.PAGE_HEADER,
                    Component: TARGETS.UNIVERSAL_SEARCH_HEADER,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Initiator: EVENT_INITIATORS.USER,
                    Element: TARGETS.UNIVERSAL_SEARCH_HEADER,
                    EventAction: 'click universal search header submit',
                },
            },
        },
    });
};

export const trackClickSignInDropdown = () => {
    return ({
        type: ActionTypes.TRACK_SIGNIN_DROPDOWN_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Click Sign in Dropdown',
                data: {
                    Section: TARGETS.PAGE_HEADER,
                    Component: TARGETS.SIGN_IN_DROPDOWN,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Initiator: EVENT_INITIATORS.USER,
                    Element: TARGETS.SIGN_IN_DROPDOWN,
                    EventAction: 'click sign in dropdown',
                },
            },
        },
    });
};
export const trackClickSignInDropdownLink = ev => {
    const url = ev.currentTarget.getAttribute('href');
    if (url.indexOf('provider') !== -1) {
        return trackClickProviderSignInDropdownLink();
    } else if (url.indexOf('signin') !== -1) {
        return trackClickPatientSignInDropdownLink();
    } else {
        return noop;
    }
};
export const trackClickProviderSignInDropdownLink = () => {
    return trackClickSignInDropdownLinkAnalytics(
        'Click header signin dropdown provider login link',
        TARGETS.SIGN_IN_DROPDOWN_PROVIDER_LOGIN,
        'Click header signin dropdown provider login link'
    );
};

export const trackClickPatientSignInDropdownLink = () =>
    trackClickSignInDropdownLinkAnalytics(
        'Click header signin dropdown patient login link',
        TARGETS.SIGN_IN_DROPDOWN_PATIENT_LOGIN,
        'Click header signin dropdown patient login link'
    );

export const trackClickSignInDropdownLinkAnalytics = (action, Element, EventAction) => {
    return {
        type: ActionTypes.TRACK_SIGNIN_DROPDOWN_LINK_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action,
                data: {
                    Section: TARGETS.PAGE_HEADER,
                    Component: TARGETS.SIGN_IN_DROPDOWN,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Initiator: EVENT_INITIATORS.USER,
                    Element,
                    EventAction,
                    Redirect: RedirectLabels.Internal,
                },
            },
        },
    };
};

const getHeaderCustomLinkTracking = (action, Element, EventAction) => ({
    analytics: {
        type: AnalyticsTypes.TrackEvent,
        action,
        data: {
            Section: TARGETS.PAGE_HEADER,
            Component: TARGETS.PAGE_HEADER_RIGHT_CONTENT_CUSTOM_LINK,
            InteractionType: INTERACTION_TYPES.CLICK,
            Element,
            Initiator: EVENT_INITIATORS.USER,
            EventAction,
            Redirect: RedirectLabels.Internal,
        },
    },
});

export const trackClickSignIn = () => ({
    type: ActionTypes.CLICK_SIGN_IN,
    meta: getHeaderCustomLinkTracking(
        'Click Page Header Sign In Link',
        TARGETS.SIGN_IN_LINK,
        'ClickSignInLink'
    ),
});

export const trackClickJoin = () => ({
    type: ActionTypes.CLICK_JOIN,
    meta: getHeaderCustomLinkTracking(
        'Click Page Header Join Link',
        TARGETS.JOIN_LINK,
        'ClickJoinLink'
    ),
});

export const trackClickHeaderCustomLink = ({ target }) => {
    const url = target.getAttribute('href');

    if (url.indexOf('signin') !== -1) {
        return trackClickSignIn();
    } else if (url.indexOf('join') !== -1) {
        return trackClickJoin();
    }
};

export const trackUsernameDropdownClick = () => ({
    type: ActionTypes.TRACK_USERNAME_DROPDOWN_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click PageHeader Username Dropdown',
            data: {
                Section: TARGETS.PAGE_HEADER,
                Component: TARGETS.PAGE_HEADER_RIGHT_CONTENT_CUSTOM_LINK,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.USERNAME_DROPDOWN,
                EventAction: 'click page header username dropdown',
            },
        },
    },
});

const trackUsernameDropdownLinkClick = (action, Element, EventAction) => {
    return {
        type: ActionTypes.TRACK_USERNAME_DROPDOWN_LINK_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action,
                data: {
                    Section: TARGETS.PAGE_HEADER,
                    Component: TARGETS.PAGE_HEADER_RIGHT_CONTENT_CUSTOM_LINK,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Initiator: EVENT_INITIATORS.USER,
                    Element,
                    EventAction,
                    Redirect: RedirectLabels.Internal,
                },
            },
        },
    };
};

export const trackUsernameDropdownMedicalTeamClick = () =>
    trackUsernameDropdownLinkClick(
        'Click PageHeader Username Dropdown MedicalTeam',
        TARGETS.USERNAME_DROPDOWN_MEDICAL_TEAM,
        'click page header username dropdown MedicalTeam'
    );

export const trackUsernameDropdownPastAppointmentsClick = () =>
    trackUsernameDropdownLinkClick(
        'Click PageHeader Username Dropdown PastAppointments',
        TARGETS.USERNAME_DROPDOWN_PAST_APPOINTMENTS,
        'click page header username dropdown PastAppointments'
    );

export const trackUsernameDropdownSettingsClick = () =>
    trackUsernameDropdownLinkClick(
        'Click PageHeader Username Dropdown Settings',
        TARGETS.USERNAME_DROPDOWN_SETTINGS,
        'click page header username dropdown Settings'
    );

export const trackUsernameDropdownCalendarClick = () =>
    trackUsernameDropdownLinkClick(
        'Click PageHeader Username Dropdown Calendar',
        TARGETS.USERNAME_DROPDOWN_SIGN_OUT,
        'click page header username dropdown Calendar'
    );

export const trackUsernameDropdownHelpClick = () =>
    trackUsernameDropdownLinkClick(
        'Click PageHeader Username Dropdown Help',
        TARGETS.USERNAME_DROPDOWN_SIGN_OUT,
        'click page header username dropdown Help'
    );

export const trackUsernameDropdownSignOutClick = () =>
    trackUsernameDropdownLinkClick(
        'Click PageHeader Username Dropdown SignOut',
        TARGETS.USERNAME_DROPDOWN_SIGN_OUT,
        'click page header username dropdown SignOut'
    );

export const trackUsernameDropdownLinks = ev => {
    const url = ev.currentTarget.getAttribute('href');
    if (url.indexOf('medicalteam') !== -1) {
        return trackUsernameDropdownMedicalTeamClick();
    } else if (url.indexOf('pastappointment') !== -1) {
        return trackUsernameDropdownPastAppointmentsClick();
    } else if (url.indexOf('editprofile') !== -1) {
        return trackUsernameDropdownSettingsClick();
    } else if (url.indexOf('provider') !== -1) {
        return trackUsernameDropdownCalendarClick();
    } else if (url.indexOf('help') !== -1) {
        return trackUsernameDropdownHelpClick();
    } else if (url.indexOf('signout') !== -1) {
        return trackUsernameDropdownSignOutClick();
    } else {
        return noop;
    }
};

export const trackSeeAllNotifications = () => ({
    type: ActionTypes.TRACK_SEE_ALL_NOTIFICATIONS,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click PageHeader Notifications SeeAllNotifications',
            data: {
                Section: TARGETS.PAGE_HEADER,
                Component: TARGETS.PAGE_HEADER_RIGHT_CONTENT_CUSTOM_LINK,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.SEE_ALL_NOTIFICATIONS,
                EventAction: 'click page header notifications SeeAllNotifications',
                Redirect: RedirectLabels.Internal,
            },
        },
    },
});

function buildSingleAppointmentEventDetails(appointment) {
    const RequestId = get(appointment, 'request_id');
    const AppointmentTime = get(appointment, 'start_time');
    const ProfessionalId = get(appointment, 'professional.professional_id');
    return {
        RequestId,
        AppointmentTime,
        ProfessionalId,
    };
}

function buildSingleNotificationEventDetails(notification) {
    const NotificationType = get(notification, 'type');
    const Message = get(notification, 'text');
    const Timestamp = get(notification, 'timestamp');
    return {
        NotificationType,
        Message,
        Timestamp,
    };
}

export function buildAppointmentsEventDetails(appointments) {
    return appointments.map(buildSingleAppointmentEventDetails);
}

export function buildNotificationsEventDetails(notifications) {
    return notifications.map(buildSingleNotificationEventDetails);
}

export const trackNotificationsCounterClick = () => {
    const state = HeaderStore.getState();
    const { unseen_notification_count: NumberOfNotifications } = userSelector(state);
    const appointments = appointmentsSelector(state);
    const notifications = notificationsSelector(state);
    const EventDetails = {
        NumberOfNotifications,
        UpcomingAppointments: buildAppointmentsEventDetails(appointments),
        Notifications: buildNotificationsEventDetails(notifications),
    };

    return {
        type: ActionTypes.TRACK_NOTIFICATIONS_COUNTER_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Click PageHeader Notifications',
                data: {
                    Section: TARGETS.PAGE_HEADER,
                    Component: TARGETS.PAGE_HEADER_RIGHT_CONTENT_CUSTOM_LINK,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Initiator: EVENT_INITIATORS.USER,
                    Element: TARGETS.NOTIFICATIONS,
                    EventAction: 'click page header notifications',
                    EventDetails,
                },
            },
        },
    };
};

export const trackNotificationClick = ({ currentTarget }) => {
    const id = currentTarget.getAttribute('data-id');
    const state = HeaderStore.getState();
    const notifications = notificationsSelector(state);
    const notification = find(notifications, n => toString(n.id) === id);
    const EventDetails = buildSingleNotificationEventDetails(notification);

    return {
        type: ActionTypes.TRACK_NOTIFICATION_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Click PageHeader Notifications Notification',
                data: {
                    Section: TARGETS.PAGE_HEADER,
                    Component: TARGETS.NOTIFICATION_DROPDOWN,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Initiator: EVENT_INITIATORS.USER,
                    Element: TARGETS.NOTIFICATIONS,
                    EventAction: 'click page header notifications notification',
                    EventDetails,
                    Redirect: RedirectLabels.Internal,
                },
            },
        },
    };
};

export const trackUpcomingAppointmentClick = ({ currentTarget }) => {
    const id = currentTarget.getAttribute('data-id');
    const state = HeaderStore.getState();
    const appointments = appointmentsSelector(state);
    const appointment = find(appointments, a => toString(a.request_id) === id);
    const EventDetails = buildSingleAppointmentEventDetails(appointment);

    return {
        type: ActionTypes.TRACK_UPCOMING_APPOINTMENTS_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Click PageHeader Notifications UpcomingAppointments',
                data: {
                    Section: TARGETS.PAGE_HEADER,
                    Component: TARGETS.NOTIFICATION_DROPDOWN,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Initiator: EVENT_INITIATORS.USER,
                    Element: TARGETS.UPCOMING_APPOINTMENTS,
                    EventAction: 'click page header notifications UpcomingAppointments',
                    EventDetails,
                    Redirect: RedirectLabels.Internal,
                },
            },
        },
    };
};

export const trackMobileLinkClick = (element, component) => ({
    type: ActionTypes.TRACK_MOBILE_MENU_LINK_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Mobile Menu Link',
            data: {
                Section: TARGETS.BURGER_MENU,
                Component: component,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: element,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: `Click ${element} Link`,
            },
        },
    },
});
